import { render } from "./BNSearch.vue?vue&type=template&id=b2772092&scoped=true"
import script from "./BNSearch.vue?vue&type=script&lang=js"
export * from "./BNSearch.vue?vue&type=script&lang=js"

import "./BNSearch.vue?vue&type=style&index=0&id=b2772092&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2772092"]])

export default __exports__